import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { v4 } from "uuid";

const notificationsAdapter = createEntityAdapter();

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: notificationsAdapter.getInitialState(),
  reducers: {
    addNotification: notificationsAdapter.addOne,
    removeNotification: notificationsAdapter.removeOne,
  },
});

export default notificationsSlice.reducer;

export const { addNotification, removeNotification } =
  notificationsSlice.actions;

const notificationSelectors = notificationsAdapter.getSelectors(
  (state) => state.notifications,
);

export const selectNotificationIds = notificationSelectors.selectIds;
export const selectNotificationById = notificationSelectors.selectById;

const showNotification = (type) =>
  createAsyncThunk(`notifications/show${type}`, (message, { dispatch }) => {
    dispatch(
      addNotification({
        id: v4(),
        severity: type.toLowerCase(),
        message,
      }),
    );
  });

export const showErrorNotification = showNotification("Error");

export const showInfoNotification = showNotification("Info");

export const showSuccessNotification = showNotification("Success");
